import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteContentNarrationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteContentNarrationMutation = { __typename?: 'RootMutationType', deleteContentNarration?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const DeleteContentNarrationDocument = gql`
    mutation deleteContentNarration($id: ID!) {
  deleteContentNarration(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeleteContentNarrationMutationFn = Apollo.MutationFunction<DeleteContentNarrationMutation, DeleteContentNarrationMutationVariables>;

/**
 * __useDeleteContentNarrationMutation__
 *
 * To run a mutation, you first call `useDeleteContentNarrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentNarrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentNarrationMutation, { data, loading, error }] = useDeleteContentNarrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContentNarrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentNarrationMutation, DeleteContentNarrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentNarrationMutation, DeleteContentNarrationMutationVariables>(DeleteContentNarrationDocument, options);
      }
export type DeleteContentNarrationMutationHookResult = ReturnType<typeof useDeleteContentNarrationMutation>;
export type DeleteContentNarrationMutationResult = Apollo.MutationResult<DeleteContentNarrationMutation>;
export type DeleteContentNarrationMutationOptions = Apollo.BaseMutationOptions<DeleteContentNarrationMutation, DeleteContentNarrationMutationVariables>;